import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid"
}
const _hoisted_2 = { class: "grid-group-image" }
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.specialPageCarouselClass)
  }, [
    (_ctx.carousel_data.length > 1)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carousel_data, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "grid-group",
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: item.url,
                  alt: item.alt,
                  width: "328",
                  height: "160"
                }, null, 8, _hoisted_3)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}